import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { PREPARE_CHECKOUT_REQUEST, PREPARE_CHECKOUT_SUCCESS, PREPARE_CHECKOUT_ERROR } from '../types';
import { useHelper } from '../helpers';
export var prepareCheckoutRequest = function prepareCheckoutRequest() {
  return {
    type: PREPARE_CHECKOUT_REQUEST
  };
};
export var prepareCheckoutSuccess = function prepareCheckoutSuccess(_ref) {
  var cart = _ref.cart,
    products = _ref.products;
  return {
    type: PREPARE_CHECKOUT_SUCCESS,
    data: cart,
    products: products
  };
};
export var prepareCheckoutError = function prepareCheckoutError(error) {
  return {
    type: PREPARE_CHECKOUT_ERROR,
    error: true,
    payload: error
  };
};
export var prepareCheckout = function prepareCheckout(options) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var chord, _useHelper, withCart, updatedCart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chord = _ref2.chord;
            _useHelper = useHelper(dispatch, getState), withCart = _useHelper.withCart;
            dispatch(prepareCheckoutRequest());
            _context.prev = 3;
            _context.next = 6;
            return withCart(chord.oms.prepareCheckout)();
          case 6:
            updatedCart = _context.sent;
            dispatch(prepareCheckoutSuccess({
              cart: updatedCart,
              products: options === null || options === void 0 ? void 0 : options.products
            }));
            return _context.abrupt("return", updatedCart);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            dispatch(prepareCheckoutError(_context.t0));
            throw _context.t0;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};